import { RelayEnvironmentStore, uploadProgressAtom } from '@/graphql/relay-env';
import type { AxiosProgressEvent } from 'axios';
import { useEffect, useState } from 'react';

type Props = {
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
};
const useRelayEnvironmentStore = (props: Props = {}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    RelayEnvironmentStore.set(uploadProgressAtom, {
      percentage: 0,
      bytes: 0,
      total: 0,
      loaded: 0,
      lengthComputable: false,
    } as AxiosProgressEvent);
    const dispose = RelayEnvironmentStore.sub(uploadProgressAtom, () => {
      const progressEvent = RelayEnvironmentStore.get(uploadProgressAtom);
      if (!progressEvent) return;

      props?.onUploadProgress?.(progressEvent);

      const { loaded, total } = progressEvent;
      if (!total) return;

      const progress = (loaded / total) * 100;
      setProgress(progress);
    });

    return () => {
      dispose();
      setProgress(0);
    };
  }, []);

  return {
    progress,
  };
};

export default useRelayEnvironmentStore;
